// @ts-strict-ignore
import { getIOSVersion, getIsApp } from '../../../../modules/AppInfo';
import {
  isAnonymous,
  ShareChannelFactory,
  ShareChannelMap,
  ShareProvider,
  ShareTarget,
  socialSharing,
  SocialSharingChannel,
} from '../../../../modules/share';
import { IS_MINE_MESSAGE } from '../constants';

type TwitterShareParams = {
  text: string;
  url?: string;
};

const getClickHandler = (
  params: TwitterShareParams,
  onSuccess: () => void,
  onFail: (err: string) => void,
) => {
  const nativeShare = () => {
    socialSharing().shareViaTwitter(
      params.text,
      null,
      params.url,
      onSuccess,
      onFail,
    );
  };

  const browserShare = () => {
    const queryParams = (
      `text=${encodeURIComponent(params.text)}&url=${encodeURIComponent(params.url)}`);
    try {
      window.open(`https://twitter.com/share?${queryParams}`);
    } catch (ex) {
      if (onFail) {
        onFail(ex);
      }
    }
  };

  // Note: Returning a "link clicked" callback instead of attaching to a `element.click` here
  return function click() {
    if (getIsApp() && socialSharing()) {
      const shareCheckString = (
        getIOSVersion()
          ? SocialSharingChannel.TwitteriOS
          : SocialSharingChannel.TwitterAndroid
      );
      socialSharing().canShareVia(
        shareCheckString,
        null,
        null,
        null,
        null,
        nativeShare,
        browserShare,
      );
    } else {
      browserShare();
    }
  };
};

const profileShare: ShareChannelFactory<ShareProvider | null> = (
  provider,
  url,
  user,
  onSuccess,
  onFail,
  message = {},
) => {
  let content: string;
  let isMine: boolean;
  if (provider) {
    isMine = !isAnonymous(user) && provider.id === user.provider_id;
    content = `I think you'll like ${provider.name}, click the link to book an appointment online`;
  } else {
    isMine = false;
    content = 'I think you\'ll like StyleSeat, click the link to book an appointment online';
  }

  const params = {
    url: message.url || url,
    text: message.text || (isMine ? IS_MINE_MESSAGE : content),
  };

  return getClickHandler(params, onSuccess, onFail);
};

const MAP: ShareChannelMap = {
  [ShareTarget.PROFILE]: profileShare,
  [ShareTarget.SEARCH]: profileShare,
  [ShareTarget.PLATFORM]: profileShare,
};

export default MAP;
